import { createContext } from 'react';
import { ServiceReportExtended } from '@sdir/httpclient/lib/clients/aps/seagoing';
import { ServiceReportQualificationResult } from '@sdir/httpclient/lib/clients/aps/application';
import { Loadable } from '../../types';

export interface IAddedQualificationsContext {
  isReady: boolean;
  addedSeagoing: Loadable<ServiceReportExtended[]>;
  addedNewSeagoing: Loadable<ServiceReportQualificationResult>;
  loadAddedSeagoing: () => void;
  loadNewAddedSeagoing: () => void;
}

export const AddedQualificationsContext = createContext<IAddedQualificationsContext>({
  isReady: false,
  addedSeagoing: {},
  addedNewSeagoing: {},
  loadAddedSeagoing: () => null,
  loadNewAddedSeagoing: () => null,
});
